import { useClient } from '@peloton/api';
import { useEndpointReturnsClasses } from '@engage/classes';
import { FilterName, getCurrentSort, getAppliedFilters } from '@engage/filters';
import { getActiveCategorySlug, isEmptyState } from '@engage/library';
import { fetchLibraryClassesByCategorySlug } from '@engage/library/api';
import { useReduxState } from '@engage/redux';
import { ok } from '@engage/result';

export const useShouldCheck = () => useReduxState(isEmptyState);

/**
 * returns whether the current query would return results if
 * the language preference was ignored
 */
export const useHasClassesWithoutLanguagePreference = () => {
  const client = useClient();
  const categorySlug = useReduxState(getActiveCategorySlug);
  const appliedFilters = useReduxState(getAppliedFilters);
  const sortValue = useReduxState(getCurrentSort);
  const page = 0;
  const shouldCheck = useShouldCheck();

  const returnsClasses = useEndpointReturnsClasses(
    () =>
      fetchLibraryClassesByCategorySlug(
        client,
        categorySlug,
        appliedFilters.concat([
          { name: FilterName.IgnoreClassLanguagePreferences, value: ['true'] },
        ]),
        sortValue,
        page,
      ),
    shouldCheck,
  );

  return shouldCheck ? returnsClasses : ok(false);
};
